export default __webpack_public_path__ + "static/banner-218ac74c5032de4ee5c09be27ad98327.jpg";